<template>

    <cms-view v-spinner="loading" :hide="loading">
        <cms-heading :title="pageTitle">
            <cms-button color="negative" icon="magicon-trash" v-if="itemId" @click="deleteProject">Verwijderen</cms-button>
        </cms-heading>

        <cms-form-panel submit-button="Opslaan" :cancel-button="true" :submitting="submitting" @submit="submit">

            <cms-form-input title="Titel" name="title" v-model.trim="pendingProject.title"
                            v-validate="'required'" data-vv-as="Titel" :error="error('title')"></cms-form-input>

            <cms-form-input title="Projectcode" name="code" v-model.trim="pendingProject.code" :disabled="project != null"
                            v-validate="'required'" data-vv-as="Projectcode" :error="error('code')"></cms-form-input>

            <cms-form-date-picker title="Start datum" name="startDate" v-model="pendingProject.startDate" input="true" :options="{ disableMobile: true }"
                                  v-validate="'required'" data-vv-as="Start datum" :error="error('startDate')"></cms-form-date-picker>

            <cms-form-date-picker title="Eind datum" name="endDate" v-model="pendingProject.endDate" input="true" :options="{ disableMobile: true }"></cms-form-date-picker>

            <cms-form-dropdown title="Munisense groep" name="munisenseGroupId" :searchable="true" empty="- Geen -"
                               v-model="pendingProject.munisenseGroupId" :options="munisenseGroupOptions"></cms-form-dropdown>

            <cms-form-row title="Locatie">
                <gmap-autocomplete class="input-normal" @place_changed="setPlace" :value="pendingProject.locationTitle" :select-first-on-enter="true" ref="autocompleteInput" />
                <i class="svg icon-search-dark"></i>
            </cms-form-row>

            <cms-form-input title="Locatie omschrijving" hint="Wanneer niet ingevuld wordt de bovenstaande locatie benaming gebruikt." name="locationManual" v-model.trim="pendingProject.locationManual"></cms-form-input>

            <cms-form-input title="Projectleider" name="projectManager" v-model.trim="pendingProject.projectManager"></cms-form-input>

            <cms-form-input type="number" min="0" name="actionDeadline" :placeholder="deadlinePlaceholder" v-model.trim.number="pendingProject.actionDeadline"
                            title="Afhandelingstermijn" hint="In dagen"
                            v-validate="'min_value:0'" data-vv-as="Afhandelingstermijn" :error="error('actionDeadline')"></cms-form-input>

            <cms-form-input type="number" min="0" name="loggerDailyPriceMultiplier" v-model.trim.number="pendingProject.loggerDailyPriceMultiplier"
                            title="Korting/toeslag loggerkosten" hint="Vermenigvuldigingsfactor (0,9 is 90% van de kosten en 1,1 is 110% van de kosten)"
                            v-validate="'min_value:0'" data-vv-as="Korting/toeslag loggerkosten" :error="error('loggerDailyPriceMultiplier')"></cms-form-input>

            <cms-form-input type="number" min="0" name="loggerUsagePriceMultiplier" v-model.trim.number="pendingProject.loggerUsagePriceMultiplier"
                            title="Korting/toeslag portalkosten" hint="Vermenigvuldigingsfactor (0,9 is 90% van de kosten en 1,1 is 110% van de kosten)"
                            v-validate="'min_value:0'" data-vv-as="Korting/toeslag portalkosten" :error="error('loggerUsagePriceMultiplier')"></cms-form-input>

            <cms-form-input type="number" min="0" name="loggerBackofficePriceMultiplier" v-model.trim.number="pendingProject.loggerBackofficePriceMultiplier"
                            title="Korting/toeslag backoffice kosten" hint="Vermenigvuldigingsfactor (0,9 is 90% van de kosten en 1,1 is 110% van de kosten)"
                            v-validate="'min_value:0'" data-vv-as="Korting/toeslag backoffice kosten" :error="error('loggerBackofficePriceMultiplier')"></cms-form-input>

            <cms-form-input type="number" min="0" name="loggerFailurePriceMultiplier" v-model.trim.number="pendingProject.loggerFailurePriceMultiplier"
                            title="Korting/toeslag storingskosten" hint="Vermenigvuldigingsfactor (0,9 is 90% van de kosten en 1,1 is 110% van de kosten)"
                            v-validate="'min_value:0'" data-vv-as="Korting/toeslag storingskosten" :error="error('loggerFailurePriceMultiplier')"></cms-form-input>

            <cms-form-input type="number" min="0" name="loggerManualRoundPriceMultiplier" v-model.trim.number="pendingProject.loggerManualRoundPriceMultiplier"
                            title="Korting/toeslag handmeetrondekosten" hint="Vermenigvuldigingsfactor (0,9 is 90% van de kosten en 1,1 is 110% van de kosten)"
                            v-validate="'min_value:0'" data-vv-as="Korting/toeslag handmeetrondekosten" :error="error('loggerManualRoundPriceMultiplier')"></cms-form-input>

        </cms-form-panel>
    </cms-view>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'
    import gql from 'graphql-tag';

    import pick from 'lodash/pick'
    import clone from 'lodash/clone'

    import getMapsAddressInfo from 'app/helpers/getMapsAddressInfo'

    import ProjectMutations from 'app/mutations/ProjectMutations'
    import ProjectQueries from 'app/queries/ProjectQueries'
    import map from "lodash/map";

    @Component({

        name: 'project-form',
        apollo: {

            project: ProjectQueries.find({

                skip(){
                    return !this.itemId;
                },

                result(result){

                    if(result && result.data) {

                        this.pendingProject = pick(result.data.viewer.findProject, [
                            'title', 'code', 'startDate', 'endDate', 'locationTitle', 'locationManual', 'address', 'postalCode', 'city', 'country', 'actionDeadline',
                            'locationLat', 'locationLng', 'projectManager', 'loggerDailyPriceMultiplier', 'loggerUsagePriceMultiplier', 'loggerBackofficePriceMultiplier', 'loggerFailurePriceMultiplier', 'loggerManualRoundPriceMultiplier', 'munisenseGroupId']);

                        this.autoSelectMunisenseGroup();
                    }
                },

                variables(){

                    return {
                        projectId: this.itemId
                    }
                }
            })
        }
    })
    export default class extends Vue
    {
        data(){

            return {

                project: null,
                pendingProject: {
                    title: null,
                    code: null,
                    startDate: null,
                    endDate: null,
                    locationTitle: null,
                    locationManual: null,
                    address: null,
                    postalCode: null,
                    city: null,
                    country: null,
                    locationLat: null,
                    locationLng: null,
                    actionDeadline: null,
                    loggerDailyPriceMultiplier: null,
                    loggerUsagePriceMultiplier: null,
                    loggerBackofficePriceMultiplier: null,
                    loggerFailurePriceMultiplier: null,
                    loggerManualRoundPriceMultiplier: null,
                    projectManager: null,
                    munisenseGroupId: null
                },

                munisenseGroups: null,

                addressInfo: null,

                submitting: false,
                submitted: false,

                loading: 0
            }
        }

        breadcrumb(){

            return [{
                title: 'Overzicht projecten',
                route: {
                    name: 'projects'
                }
            }, this.pageTitle];
        }

        created(){

            this.logger = this.$logger.child('ProjectForm');

            this.listenerSet = false;
        }

        mounted(){

            this.$watch('munisenseGroups', () => this.autoSelectMunisenseGroup());
            this.$watch('pendingProject.code', () => this.autoSelectMunisenseGroup());

            this.fetchMunisenseGroups();
        }

        updated(){

            const $autocomplete = this.$refs.autocompleteInput;
            if($autocomplete && !this.listenerSet){

                $autocomplete.$el.addEventListener('keydown', (event) => {

                    // Prevent form submission on enter
                    if(event.keyCode === 13){
                        event.preventDefault();
                    }
                });

                this.listenerSet = false;
            }
        }

        get pageTitle(){

            var pageTitle = null;

            if(this.itemId){
                pageTitle = this.project ? this.project.code : '';
            }
            else {
                pageTitle = 'Project toevoegen';
            }

            return pageTitle;
        }

        get itemId(){

            return this.$route.params.id;
        }

        setPlace(place) {

            this.pendingProject.locationTitle = this.$refs.autocompleteInput.$el.value;

            this.addressInfo = getMapsAddressInfo(place);
        }

        onQueryError(){

            this.$toast.error('Het project kon niet worden opgehaald');
        }

        error(field){

            return this.submitted ? this.errors.first(field) : null;
        }

        submit(){

            this.submitted = true;

            this.$validator.validateAll().then(success => {

                if (!success) {

                    this.$toast.error('Er zijn één of meerdere fouten');
                }
                else {

                    this.submitting = true;
                    var projectData = clone(this.pendingProject);
                    projectData.actionDeadline = projectData.actionDeadline ? parseInt(projectData.actionDeadline) : null;

                    if(projectData.loggerDailyPriceMultiplier === ''){
                        projectData.loggerDailyPriceMultiplier = null;
                    }

                    if(projectData.loggerUsagePriceMultiplier === ''){
                        projectData.loggerUsagePriceMultiplier = null;
                    }

                    if(projectData.loggerBackofficePriceMultiplier === ''){
                        projectData.loggerBackofficePriceMultiplier = null;
                    }

                    if(projectData.loggerFailurePriceMultiplier === ''){
                        projectData.loggerFailurePriceMultiplier = null;
                    }

                    if(projectData.loggerManualRoundPriceMultiplier === ''){
                        projectData.loggerManualRoundPriceMultiplier = null;
                    }

                    const locationText = this.$refs.autocompleteInput.$el.value;

                    if(this.addressInfo) {

                        var address = '';
                        if(this.addressInfo.route) {
                            address += this.addressInfo.route;
                        }

                        if(this.addressInfo.street_number) {
                            address += ' ' + this.addressInfo.street_number;
                        }

                        projectData.address = address === '' ? null : address;
                        projectData.postalCode = this.addressInfo.postal_code ? this.addressInfo.postal_code : null;
                        projectData.city = this.addressInfo.locality ? this.addressInfo.locality : null;
                        projectData.country = this.addressInfo.country ? this.addressInfo.country : null;
                        projectData.locationLat = this.addressInfo.latitude ? this.addressInfo.latitude : null;
                        projectData.locationLng = this.addressInfo.longitude ? this.addressInfo.longitude : null;
                    }
                    else if(!locationText){

                        projectData.locationTitle = null;
                        projectData.address = null;
                        projectData.postalCode =  null;
                        projectData.city = null;
                        projectData.country = null;
                        projectData.locationLat = null;
                        projectData.locationLng = null;
                    }

                    if(this.project) {

                        projectData.id = this.project.id;

                        ProjectMutations.update(projectData).then(() => {

                            this.logger.info('Project updated');
                            this.$toast.success('Het project is opgeslagen');

                            this.submitting = false;

                            this.$router.push({
                                name: 'projects'
                            });

                        }).catch(e => this.handleSubmitError(e));
                    }
                    else {

                        ProjectMutations.create(projectData).then(() => {

                            this.logger.info('Project created');
                            this.$toast.success('Het project is aangemaakt');

                            this.submitting = false;

                            this.$router.push({
                                name: 'projects'
                            });

                        }).catch(e => this.handleSubmitError(e));
                    }
                }
            });
        }

        handleSubmitError(e){

            const errors = map(e.graphQLErrors, 'message');
            this.logger.error('Error saving project', e);

            if(errors.indexOf('project-code-taken') >= 0){
                this.$toast.error('De ingevoerde projectcode is al in gebruik');
            }
            else {
                this.$toast.error('Het project kon niet worden opgeslagen');
            }

            this.submitting = false;
        }

        async fetchMunisenseGroups(){

            const munisense = di.get('munisense');

            try {

                this.munisenseGroups = await munisense.getGroups();
            }
            catch(e){

                this.logger.error('Error fetching Munisense groups');
                this.$toast.error('De munisense groepen konden niet worden opgehaald');
            }
        }

        autoSelectMunisenseGroup(){

            if(!this.munisenseGroups || !this.pendingProject.code){
                return;
            }

            let autoSelect = false;

            if(this.itemId && !this.pendingProject.munisenseGroupId){
                autoSelect = true;
            }
            else if(!this.itemId){
                autoSelect = true;
            }

            if(!autoSelect){
                return;
            }

            const group = Object.values(this.munisenseGroups).find(group => group.name.indexOf(this.pendingProject.code) >= 0);
            if(group){

                this.logger.info(`Auto selected group ${group.group_id}`);
                this.pendingProject.munisenseGroupId = group.group_id;
            }
        }

        deleteProject(){

            this.$alert.confirmDelete('Weet je zeker dat je dit project wilt verwijderen?', true).then(({ result, modal }) => {

                if(!result){
                    return;
                }

                ProjectMutations.delete(this.project.id).then(() => {

                    this.logger.info(`Project ${this.project.id} deleted`);

                    this.$modal.close(modal);
                    this.$toast.success('Het project is verwijderd');

                    this.$router.replace({ name: 'projects' });

                }).catch(e => {

                    this.logger.error(`Error deleting project ${this.project.id}`, e);

                    this.$modal.close(modal);
                    this.$toast.error('Het project kon niet worden verwijderd');
                });
            });
        }

        get deadlinePlaceholder(){

            return di.get('config').defaultActionDeadline.toString();
        }

        get munisenseGroupOptions(){

            if(!this.munisenseGroups){
                return [];
            }

            return Object.values(this.munisenseGroups).map(group => ({
                label: group.name,
                value: group.group_id
            }));
        }
    }

</script>
